<template>
    <div>
        <!-- 不支持多选，过滤逻辑调整过 -->
        <el-select
            style="width: 100%"
            v-model="model_value"
            :placeholder="model_name"
            :clearable="is_clearable"
            filterable
            @change="onChange"
            :filter-method="onFilter"
            :disabled="is_disable"
            v-show="is_show"
            @clear="onClear"
            @visible-change="onVisibleChange"
            ref="commonSelect"
        >
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-tooltip v-if="insert_router != ''" class="Tooltip" content="新增" placement="top-start">
            <i class="el-icon-plus" @click="insert()" style="cursor: pointer"></i>
        </el-tooltip>
        <el-tooltip v-if="insert_router != ''" class="Tooltip2" content="刷新" placement="top-start">
            <i class="el-icon-refresh" @click="initData()" style="cursor: pointer"></i>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    name: 'commonDropDown',
    props: {
        model_key: {
            // 请求后台的参数key
            type: String
        },
        model_name: {
            // 下拉框预显示名称
            type: String
        },
        insert_router: {
            type: String,
            default: ''
        },
        model_value_default: {
            // 默认值，编辑页面需要用
            default: ''
        },
        request_uri: {
            // 下拉框请求后台的地址映射
            type: String
        },
        request_params: {
            // 下拉框请求后台的参数
            type: Object,
            default: function () {
                return {};
            }
        },
        is_init: {
            // 是否加载的时候立即请求后台或本地数据
            type: Boolean,
            default: true
        },
        is_clearable: {
            type: Boolean,
            default: true
        },
        initFromLocalData: {
            // 请求本地的数据
            type: Array
        },
        is_disable: {
            // 是否禁用
            type: Boolean,
            default: false
        },
        is_show: {
            // 是否显示
            type: Boolean,
            default: true
        },
        get_select_item: {
            // 是否需要获取选中行的其他数据
            type: Boolean,
            default: false
        },
        display_name: {
            type: String,
            default: 'name'
        },
        select_value: {
            type: String,
            default: 'rid'
        }
    },
    data() {
        return {
            defaultOptions: [],
            options: [],
            model_value: '',
            request_params_plus: null
        };
    },
    watch: {
        // 列表上使用该组件，请遵循动态key+formData来实现数据映射
        model_key() {
            this.setDefaultValue();
        },
        model_value_default() {
            this.setDefaultValue();
        }
    },
    mounted() {
        if (this.is_init) {
            this.initData();
        }
    },
    methods: {
        insert() {
            if (this.insert_router == '') {
                return true;
            }

            let path = '';

            if (this.insert_router[0] != '/') {
                path = '/' + this.insert_router;
            } else {
                path = this.insert_router;
            }

            window.open('#' + path);
        },
        reset() {
            this.model_value = '';
        },
        setDefaultValue() {
            // 使用try catch 来 break
            try {
                this.options.forEach((item) => {
                    if (item.value === this.model_value_default) {
                        this.model_value = this.model_value_default;
                        throw new Error('ok');
                    }
                });
                this.model_value = '';
            } catch (e) {}
        },
        // 初始化数据
        initData() {
            if (this.initFromLocalData) {
                this.options = [];
                this.defaultOptions = [];
                // 外面调用的地方转好了，这里就直接用 value label 吧。 data 暂时没需求
                this.initFromLocalData.forEach((item) => {
                    this.options.push({
                        value: item['value'],
                        label: item['label']
                    });
                    this.defaultOptions.push({
                        value: item['value'],
                        label: item['label']
                    });
                });
                this.setDefaultValue();
            } else {
                this.$api[this.request_uri](this.request_params_plus || this.request_params)
                    .then((res) => {
                        this.options = [];
                        this.defaultOptions = [];
                        let data = res.data;
                        data.forEach((item) => {
                            this.options.push({
                                value: item[this.select_value],
                                label: item[this.display_name],
                                data: this.get_select_item ? item : {}
                            });
                            this.defaultOptions.push({
                                value: item[this.select_value],
                                label: item[this.display_name],
                                data: this.get_select_item ? item : {}
                            });
                        });
                        this.setDefaultValue();
                    })
                    .catch((error) => {});
            }
        },
        onFilter(query) {
            if (query != '') {
                this.options = this.defaultOptions.filter((option) => {
                    return option.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
                if (this.options.length == 1) {
                    this.$refs.commonSelect.blur();
                    this.model_value = this.options[0].value;
                    this.onChange(this.options[0].value);
                }
            } else {
                this.options = this.defaultOptions;
            }
            return true;
        },
        onVisibleChange() {
            if (this.options.length == 0) {
                this.options = this.defaultOptions;
            }
        },
        onClear() {
            this.options = this.defaultOptions;
        },
        onChange(value) {
            if (this.get_select_item) {
                this.$emit('onDropChange', this.model_key, this.model_value, this.getSelectItem());
            } else {
                this.$emit('onDropChange', this.model_key, this.model_value);
            }
        },
        getSelectItem() {
            var res = this.options.find((v) => {
                if (v['value'] == this.model_value) {
                    return true;
                }
                return false;
            });

            return res['data'] || {};
        }
    }
};
</script>

<style>
</style>